import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  header: <PortalMessage id='t.app.orders.operation.detail.title' defaultMessage='Operation Detail' />,
  goToOperationManagement: (
    <PortalMessage id='t.app.operationsManagement.title' defaultMessage='Operations Management' />
  ),
  goToOrderDetail: <PortalMessage id='t.app.header.orders.detail' defaultMessage='Order Detail' />,
  operation: (operation) => (
    <PortalMessage id='t.app.orders.operation.detail.subtitle' defaultMessage='Operation ID' values={{ operation }} />
  ),
  summary: <PortalMessage id='t.app.orders.operation.detail.tabs.summary' defaultMessage='Summary' />,
  securityWarnings: (
    <PortalMessage id='t.app.orders.operation.detail.tabs.securityWarnings' defaultMessage='Security Warnings' />
  ),
  additionalInfo: (
    <PortalMessage id='t.app.orders.operation.detail.tabs.additionalInfo' defaultMessage='Additional Info' />
  ),
  payToCardDetails: (
    <PortalMessage
      id='t.app.orders.operation.detail.tabs.payToCardDetails'
      defaultMessage='Pay-to-card details'
    />
  ),
  customerInfo: (
    <PortalMessage id='t.app.orders.tab.customerInfo' defaultMessage='Customer Info' />
  ),
  currency: (
    <PortalMessage id='t.app.orders.operation.detail.tabs.currency' defaultMessage='Multicurrency' />
  ),
  dcc: <PortalMessage id='t.app.orders.operation.detail.tabs.dcc' defaultMessage='Dynamic Currency Conversion' />,
  loyaltyProgram: (
    <PortalMessage id='t.app.orders.operation.detail.tabs.loyalty' defaultMessage='Alpha Bank Bonus Loyalty Program' />
  )
}

export const captions = defineMessages({
  goToOperationManagement: {
    id: 't.app.operationsManagement.title',
    defaultMessage: 'Operations Management'
  },
  goToOrderDetail: {
    id: 't.app.header.orders.detail',
    defaultMessage: 'Order Detail'
  },
  openCloseAccordion: {
    id: 't.app.accessibility.project.openCloseAccordion.ariaLabel',
    defaultMessage: 'Toggle accordion visibility'
  },
  pageTitle: {
    id: 't.app.orders.operation.detail.page.title',
    defaultMessage: 'XPay | Operation Detail'
  }
})

export default formattedMessage
